import { CollectiveAgreementPageContentResponseModel } from '@shared/integrations/umbraco-taf-delivery-api/models';
import Alerts from "@shared/components/Alerts.tsx";
import ContractList from "@my-pages/features/contracts/components/ContractList.tsx";


interface IContractsPage {
    content: CollectiveAgreementPageContentResponseModel;
}
const ContractsPage = ({ content }: IContractsPage) => {
    return (
        <>
            <h1 className='page-title'>Kollektivavtal</h1>
            <div className='slide-up-fade-in'>
                {content?.properties?.importantMessages && (
                    <div className='mb-4'>
                        <Alerts alerts={content?.properties?.importantMessages} />
                    </div>
                )}
                <div className='card card-body mb-4'>
                    <div className='row'>
                        <div className='col-12'>
                            <ContractList contracts={content.properties?.contracts} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ContractsPage;
